// Konfiguracja demo Plugin Commerce — JEDYNE miejsce z danymi snippetu.
//
// Wklej tu wartości ze snippetu embed, a widżet zamontuje się na
// /plugin-commerce/demo. To jest ten snipet, który podpinamy pod prezentacje
// i testy UX. UWAGA: loader i token muszą być z tego samego środowiska. Token
// tego biznesu (UAT) ma na allowliście origin https://uat.embed.spotto.pl, więc
// loaderUrl MUSI wskazywać uat.embed.spotto.pl. Prod embed.spotto.pl z tym
// tokenem daje 401 (prod API) / 403 (origin spoza allowlisty) i pusty widżet.
//
//   loaderUrl  — adres zhostowanego loadera z pakietu `embed`
//                (packages/embed → dist/loader/loader.js),
//                UAT: https://uat.embed.spotto.pl/v1/loader.js
//   businessId — data-business-id obiektu demonstracyjnego
//   embedToken — data-embed-token
//   mode       — data-mode: 'booking' | 'shop' | 'combined'
//   dataset    — pozostałe atrybuty data-* (opcjonalne): facility-id, product-id,
//                theme, accent, radius, locale
//
// Dopóki loaderUrl / businessId / embedToken są puste, strona demo pokazuje
// stan „skonfiguruj snippet" zamiast wstrzykiwać niedziałający skrypt.

export interface PluginCommerceDemoConfig {
  loaderUrl: string
  businessId: string
  embedToken: string
  mode: 'booking' | 'shop' | 'combined' | string
  dataset?: Record<string, string>
}

export const pluginCommerceDemoConfig: PluginCommerceDemoConfig = {
  loaderUrl: 'https://uat.embed.spotto.pl/v1/loader.js',
  businessId: '4f0ae10c-d19f-4ed2-b341-b451895efd96',
  embedToken: 'emb_pk_live_9df33fc9c3cb98797772f5717fac304f',
  mode: 'all',
  dataset: {
    theme: 'dark',
    accent: '#d9663f', // stonowany pomarańcz, zgrany z tokenem `commerce-500`
  },
}

/** Widżet montujemy tylko, gdy komplet danych DEV jest uzupełniony. */
export function isDemoConfigured(cfg: PluginCommerceDemoConfig): boolean {
  return Boolean(cfg.loaderUrl && cfg.businessId && cfg.embedToken && cfg.mode)
}
